import type { TimelineI, TimelineLabelI } from "tweenly"
export const defaultTimeline: TimelineI = {
    //initState,endState..  moved to editor.settings.timeline
    /// TO DO  - move other values to editor.settings.timeline
    minduration: 30,
    labels: [],
    freezeTime: null,
    onInitCode: null,
    onUpdateCode: null,
    introEnd: null,
    outroStart: null,
}

export const defaultTimelineLabel: TimelineLabelI = {
    title: "label",
    time: 0,
    type: "continue",
    jumpto: "",
    onLabelCode: null,
}
